// Tiny feature flag layer. Single source of truth for FE-side toggles that
// gate behavior changes during a rollout. Read once at module load — these
// are build-time constants from import.meta.env, not per-request state.

// A2UI interactive games (Phase 3.6 / engine plan B.2 first-mechanic flip).
// When true, FindingsStep adds `is_interactive: true` to /activities POSTs.
// Engine then emits both `layer` and `a2ui_layer` SSE events; ai-service
// skips Anthropic codegen for interactive layers; FE renders via
// A2uiRenderer for any registered mechanic_id, and the stub fallback
// renders for un-registered ones.
//
// Defaults:
//   - dev: ON (so local testing exercises the new path without env setup)
//   - everything else: OFF unless VITE_A2UI_ENABLED=true is set
//
// Production rollout: flip the env var on Vercel once engine A.1 is deployed
// AND a critical mass of mechanics are registered + verified.
export const A2UI_ENABLED =
  import.meta.env.VITE_A2UI_ENABLED === 'true' || import.meta.env.DEV

// May 2026 evaluation wizard (Workstream 1). When true, ModuleRouter mounts
// the new `EvaluationWizard` instead of the legacy `QuestionFlow`. Coexists
// with the legacy path until production cutover; see
// specs/May2026_01_Evaluation_FE_v2.md §Coordination + cutover.
//
// Defaults:
//   - dev: ON (so local testing exercises the new wizard against the new BE)
//   - everything else: OFF unless VITE_NEW_EVAL_WIZARD=true is set
//
// Production rollout: flip the env var on Vercel once evaluation-service is
// deployed and stale in-flight evaluations have been ABANDONED via the BE
// cutover script.
export const NEW_EVAL_WIZARD =
  import.meta.env.VITE_NEW_EVAL_WIZARD === 'true' || import.meta.env.DEV

// Ask Hopscotch — the parent companion (July 2026 redesign of the AI chat
// panel). When true, ThreePanelLayout mounts <CompanionRoot> instead of the
// legacy <RightPanel>, and AppHeader hides its chat toggle (the companion
// brings its own launchers). Old RightPanel + its state fields are deleted
// at production cutover.
//
// Defaults:
//   - dev: ON
//   - everything else: OFF unless VITE_ASK_HOPSCOTCH=true is set
export const ASK_HOPSCOTCH =
  import.meta.env.VITE_ASK_HOPSCOTCH === 'true' || import.meta.env.DEV

// Upload a book — the full-page pressed-theme capture flow (July 2026
// redesign). When true, the Library/Home upload launchers open the new
// <UploadFlowPage> overlay (store `uploadEntry`) instead of navigating to the
// legacy in-panel UploadFlow under the MY_GUIDES 'new' sentinel. The old flow
// is deleted at production cutover.
//
// Defaults:
//   - dev: ON
//   - everything else: OFF unless VITE_UPLOAD_V2=true is set
export const UPLOAD_V2 =
  import.meta.env.VITE_UPLOAD_V2 === 'true' || import.meta.env.DEV

